import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { PlusIcon } from '@/components/icons/plus-iocn';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { useEditTargetsContext } from '@/contexts/edit-targets-context';

import { Form } from './form';

export function EditTargetsContent() {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { hiringGoal, hiringGoalUrl } = useEditTargetsContext();

  const onFormChange = (enabled: boolean) => {
    setIsFormDirty(enabled);
  };

  const showSpinner = (isSaving: boolean) => {
    setIsSaving(isSaving);
  };

  if (!hiringGoal) return null;

  const { is_current: isCurrent } = hiringGoal;

  return (
    <>
      <Form
        onFormChange={onFormChange}
        hiringGoal={hiringGoal}
        showSpinner={showSpinner}
      >
        <DialogFooter className="min-h-0 flex-wrap gap-2">
          {isCurrent ? (
            <Button
              type="submit"
              disabled={!isFormDirty || isSaving}
              className="h-auto min-h-9 max-w-full shrink-0 py-2 whitespace-normal"
            >
              {isSaving && <Loader2 className="animate-spin" />}
              <FormattedMessage
                defaultMessage="Save"
                description="Footer: commit hiring goal target changes"
              />
            </Button>
          ) : (
            <Button>
              <PlusIcon />
              <Link to={String(hiringGoalUrl)} target="_blank">
                <FormattedMessage
                  defaultMessage="Add Hiring Goal"
                  description="Fallback CTA: open Hire when there is no goal to edit"
                />
              </Link>
            </Button>
          )}
        </DialogFooter>
      </Form>
    </>
  );
}
